import { ErrorBox, Loading, Pane, Text } from "shared";
import { useTranslation } from "react-i18next";
import { useHcp } from "api/hooks/useHCPs";
import { Status } from "./Status";
import Summary from "./Summary";
import HcpInfo from "./HcpInfo";
import ToggleFeatures from "./ToggleFeatures";
import Services from "./Services";

const Account = () => {
  const { t } = useTranslation();
  const { data: hcp, error, isLoading, isSuccess } = useHcp();

  const mainEm = hcp && (
    <>
      <Pane><Status /></Pane>
      <Pane>
        <Summary />
        <HcpInfo />
        <ToggleFeatures />
        <Services />
      </Pane>
    </>
  );

  const altEm = (
    <Pane>
      {error && <ErrorBox error={error} verbose dark />}
      {isLoading && <Loading />}
    </Pane>
  );

  return (
    <div>
      <Text paragraph caption secondary>
        {t`hcp.account`}
      </Text>
      {isSuccess ? mainEm : altEm}
    </div>
  );
};

export default Account;
